import React from 'react';
import {Icon, TriggerWrapperV2} from '@priority-software/priority-style-react';
import {Label} from '../../../components/Common/Label';

export const FilterIconTrigger = ({
    icon,
    skin = null,
    disabled = false,
    title = '',
    width,
    fontSize,
    onClick = null,
    isOpen,
    onClose
}) => {
    return (
        <TriggerWrapperV2 isOpen={isOpen}>
            <div className="flex-container filters-trigger" style={{minWidth: width}}>
                <Label
                    componentClasses="trigger-title"
                    textColor="primary-500"
                    skin="subtitle-2"
                    style={{fontSize: fontSize + 'pt'}}
                >
                    {title}
                </Label>

                <Icon
                    icon={icon}
                    componentClasses="trigger-icon"
                    iconColor="primary-500"
                    disabled={disabled}
                    onClick={e => {
                        onClose();
                    }}
                    style={{
                        width: fontSize + 7.5 + 'pt',
                        height: fontSize + 7.5 + 'pt',
                        fontSize: fontSize + 7.5 + 'pt'
                    }}
                />
            </div>
        </TriggerWrapperV2>
    );
};
